import * as Sentry from "@sentry/react";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";
import { Analytics } from "@vercel/analytics/react";
import { router } from "./routes";
import { AuthProvider } from "./contexts/AuthContext";

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster position="bottom-right" />
        <Analytics />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  );
}
